import { render, staticRenderFns } from "./IconCog.vue?vue&type=template&id=2dfe78fc&"
import script from "./IconCog.vue?vue&type=script&lang=js&"
export * from "./IconCog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports